import type { PokerGameTile as PokerGameTileType } from '@ps/poker-games-tile-mappers';
import classNames from 'clsx';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { Dispatch } from '@swf/core/store';
import { GameType, PokerModalRoutes } from '@swf/core/types/Poker';
import { useHomeGamesWidget } from '@swf/poker';

import styles from './DeleteGame.scss';
import { TXTCLI_Cancel_Table, TXTCLI_Cancel_Tournament } from './DeleteGameButton.messages.json';

interface Props {
  games: PokerGameTileType[];
  clubId: number;
}

const DeleteGameButton: React.FC<Props> = ({ games, clubId }) => {
  const { modal } = useDispatch<Dispatch>();
  const { widgetId } = useWidget();
  const { widgetSelect } = useHomeGamesWidget(widgetId);
  const selectedGames = useSelector(widgetSelect.selectedGames);
  const [{ type }] = games;
  const isVisible = games.find((game) => selectedGames.includes(game.id));
  const translation =
    (type as unknown) === GameType[GameType['Cash Game']]
      ? TXTCLI_Cancel_Table
      : TXTCLI_Cancel_Tournament;

  return (
    <StarsButton
      className={classNames(styles.actionButton, { [styles.visible]: isVisible })}
      variant="tertiary"
      size="small"
      translation={translation}
      onClick={() => {
        modal.enqueue({
          path: PokerModalRoutes.deleteGamePrompt,
          locationState: { clubId, type, widgetId }
        });
      }}
    />
  );
};

export default DeleteGameButton;
